import React from 'react';
import classNames from 'classnames/bind';
import { AnimatePresence, motion } from 'framer-motion';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var fadeVariants = {
  initial: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.4,
      ease: 'easeInOut'
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut'
    }
  }
};
export var TabWrapper = function TabWrapper(_ref) {
  var activeTab = _ref.activeTab,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AnimatePresence, null, /*#__PURE__*/React.createElement(motion.div, {
    animate: activeTab ? 'visible' : 'initial',
    className: cx('container'),
    exit: "exit",
    initial: "initial",
    variants: fadeVariants
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('space')
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('tab')
  }, children))));
};